export default __webpack_public_path__ + "static/media/404.904f8fcb.png";